import React from 'react'
import Icon from 'react-icon-base'

const Educationalbackground = props => (
  <Icon viewBox="0 0 40 40" {...props}>
    <g id="Educationalbackground" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Educationalbackground" transform="translate(-130.000000, -3431.000000)">
        <rect id="Rectangle" fill="#F1F1F1" x="0" y="8" width="1200" height="3822" />
        <g id="Group" transform="translate(32.000000, 410.000000)">
          <g id="Group-7" transform="translate(0.000000, 2943.000000)">
            <rect
              id="Rectangle-Copy"
              stroke="#DDDDDD"
              fill="#FFFFFF"
              x="0.5"
              y="0.5"
              width="1135"
              height="207"
              rx="4"
            />
            <g id="Group-20" transform="translate(30.000000, 78.000000)" stroke="#3498DB">
              <g id="Group" transform="translate(68.000000, 0.000000)">
                <path
                  d="M17.1046433,1.29207094 C17.3576062,1.18631618 17.6423938,1.18631618 17.8953567,1.29207094 L17.8953567,1.29207094 L33.1299439,7.66110792 C33.3910873,7.77028266 33.5832565,7.97497111 33.6828462,8.21765173 C33.7824358,8.46033234 33.7894459,8.74100513 33.6802712,9.00214854 C33.5820822,9.2370142 33.4000097,9.42693874 33.1695458,9.53492763 L33.1695458,9.53492763 L27.7499219,12.0740596 L27.749998,24.0753094 C26.469156,25.7226928 22.0033006,26.4785 16.9875,26.4785 C12.0159373,26.4785 7.57513877,25.7410157 6.39591848,24.4298916 L6.39591848,24.4298916 L6.21582714,11.5898389 L1.83050354,9.53495077 C1.57419953,9.41485391 1.39083867,9.20223888 1.30157803,8.95557207 C1.21231739,8.70890525 1.21715697,8.42818665 1.33725383,8.17188264 C1.44526586,7.9413694 1.6351904,7.75929687 1.87005606,7.66110792 L1.87005606,7.66110792 Z"
                  id="Combined-Shape"
                  strokeWidth="2.05"
                />
                <line
                  x1="2.6375"
                  y1="10.0375"
                  x2="2.6375"
                  y2="20.2875"
                  id="Line-4"
                  strokeWidth="1.025"
                  strokeLinecap="square"
                />
                <path
                  d="M2.6375,22.1864262 L3.80580431,25.925 L1.46919569,25.925 L2.6375,22.1864262 Z"
                  id="Triangle"
                  strokeWidth="2.05"
                />
                <polyline id="Path-3" strokeWidth="2" strokeLinecap="round" points="10 13 18 16 24 13" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </Icon>
)

Educationalbackground.defaultProps = {
  size: 30
}

export default Educationalbackground
